export enum TransactionReportType {
  Basic = 'SIMPLIFIED_TRANSACTIONS_GROUPED',
  Full = 'DETAILED_TRANSACTIONS_GROUPED',
  BasicPDSP = 'SIMPLIFIED_TRANSACTIONS_GROUPED_PDSP',
  FullPDSP = 'DETAILED_TRANSACTIONS_GROUPED_PDSP',
  Standard = 'STANDARD',
  Custom = 'CUSTOM',
}
